var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7733 19.6161V16.7516H10.0837V7.05781H8.25039V10.037H1.30664V2.38281H8.25039V5.2474H13.7733V2.38281H20.6941V10.037H13.7733V7.05781H11.9171V14.9411H13.7733V11.962H20.6941V19.6161H13.7733ZM3.13997 4.19323V8.22656V4.19323ZM15.5837 13.7724V17.8057V13.7724ZM15.5837 4.19323V8.22656V4.19323ZM15.5837 8.22656H18.8608V4.19323H15.5837V8.22656ZM15.5837 17.8057H18.8608V13.7724H15.5837V17.8057ZM3.13997 8.22656H6.43998V4.19323H3.13997V8.22656Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowOutlined);
export default __webpack_public_path__ + "static/media/flow-outlined.61f91c7b.svg";
export { ForwardRef as ReactComponent };